import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy, ElementRef } from "@angular/core";
import { CreativesService } from "./creative.services";
import { CreativeSortField } from "./creative-sort.enum";
import { DropdownValue } from "../shared/dropdown.model";
import { PageSizeSelectionComponent } from "../shared/page-size-selection.component";
import { NotificationService } from "../core/services";
import { SortService } from '../shared/sort.service';
import { ICreativeViewModel, CreativeProcessingStatusEnum } from "./creative.model";
import { SortModel } from "../shared/sort.model";
import { CreativeFilterModel } from "./creative-filter.model";
import { CreativeFilterComponent } from "./creative-filter.component";
import { CustomHorizontalScrollService } from "../shared/custom-horizontal-scroll.service";
import { FilterItemsService } from "../reports";

@Component({
  moduleId: module.id,
  templateUrl: "creative.component.html",
})
export class CreativeComponent implements OnInit, AfterViewInit, OnDestroy {
  data: ICreativeViewModel[]
  errorMessage: string;
  pageNumber: number = 1;
  totalCount: number;
  pageSize: number = 0;
  showOverlay: boolean;

  nameSort: SortModel = new SortModel(CreativeSortField.Name, SortModel.ascIcon);
  startDateSort: SortModel = new SortModel(CreativeSortField.StartDate, SortModel.disabledIcon);
  endDateSort: SortModel = new SortModel(CreativeSortField.EndDate, SortModel.disabledIcon);
  positionSort: SortModel = new SortModel(CreativeSortField.Position, SortModel.disabledIcon);
  publisherSort: SortModel = new SortModel(CreativeSortField.Publisher, SortModel.disabledIcon);
  providerSort: SortModel = new SortModel(CreativeSortField.Provider, SortModel.disabledIcon);
  processingStatusSort: SortModel = new SortModel(CreativeSortField.ProcessingStatus, SortModel.disabledIcon);

  useLightClass: boolean = true;
  showPublishers: boolean = false;
  showProviders: boolean = false;
  private filters: CreativeFilterModel;
  private sortField: SortModel;
  private sortDirectionAsc: boolean = true;
  private inXhrGetCreatives: any;

  @ViewChild("pageSizeSelection") pageSizeSelectionComponent: PageSizeSelectionComponent
  @ViewChild("creativeFilter") creativeFilterComponent: CreativeFilterComponent

  constructor(private creativeService: CreativesService,
    private scrollService: CustomHorizontalScrollService,
    private sortService: SortService,
    private filterItemsService: FilterItemsService,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.sortField = this.nameSort;
    this.showPublishers = this.filterItemsService.getPublishersIds().length >= 1;
    this.showProviders = this.filterItemsService.getProvidersIds().length > 1;
  }

  public getCreatives(page: number): void {
    this.creativeFilterComponent.disable();
    if (this.inXhrGetCreatives) {
      this.inXhrGetCreatives.unsubscribe();
    }
    this.showOverlay = true;
    this.inXhrGetCreatives = this.creativeService.getFilteredCreatives(this.sortField.fieldId, this.sortDirectionAsc, page, this.pageSize, this.filters.name, this.filters.publisherIds)
      .subscribe((res: any) => {
        this.totalCount = res.json().total;
        this.pageNumber = page;
        this.data = <Array<ICreativeViewModel>>res.json().data;
      }, error => this.errorMessage = error, () => this.onCompletedGetCreatives());
  }

  private onCompletedGetCreatives(): void {
    this.showOverlay = false;
    this.creativeFilterComponent.enable();
    this.toggleHorizontalScroll();
  }

  onResize(event) {
    this.toggleHorizontalScroll();
  }

  private toggleHorizontalScroll() {
    let self = this;
    setTimeout(function () {
      self.scrollService.toggleHorizontalScroll();
    }, 10);
  }

  onSortChanged(sort: SortModel) {
    let sortResult = this.sortService.toggleTableColumnSort(this.sortField, this.sortDirectionAsc, sort);
    this.sortField = sortResult.existingSortModel;
    sort = sortResult.selectedSortModel;
    this.sortDirectionAsc = sortResult.sortDiresctionAsc;
    this.getCreatives(1);
  }

  onPageSizeChanged(item: DropdownValue) {
    this.pageSize = item.value;
    this.pageNumber = 1;
    this.getCreatives(this.pageNumber);
  }

  ngAfterViewInit() {
    this.pageSize = this.pageSizeSelectionComponent.defaultPageSizeSelection.value;
    this.getCreatives(1);
    // tree select init
    $("#publishers-select").treeMultiselect({ enableSelectAll: true, sortable: false });
  }

  filter(filters: CreativeFilterModel) {
    this.filters = filters;
    if (this.pageSizeSelectionComponent && this.pageSize)
      this.getCreatives(1);
  }

  onCreativeCreated() {
    this.notificationService.showInfo('Your request has been registered and is being processed. Please check this page later to see the progress.');
    this.getCreatives(1);
  }

  ngOnDestroy() {
    if (this.inXhrGetCreatives) {
      this.inXhrGetCreatives.unsubscribe();
    }
    this.scrollService.toggleHorizontalScroll(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/creatives/creative.component.ts